export default __webpack_public_path__ + "static/media/What we did when we started.1e2fe653.png";